<!-- ADMIN COMPONENT TO ADD ARTWORK PIECE TO FIREBASE -->

<template>
	<div>

<!--MODAL CONTAINING EDIT FORM -->

  	<b-modal id="modalForm" size="xl" title="New Portfolio Piece" ok-only ok-variant="primary" ok-title="Add Piece" ref="modalForm" style="padding: 0!important; margin-top:8vh!important;" @modal-ok="onCreatePiece">

<!-- ALERT IF THERE IS AN ERROR WITH FORM -->

      <b-row v-if="error">
        <b-col sm-12>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </b-col>
      </b-row>

<!-- BEGIN FORM -->

      <b-form @submit.stop.prevent="onCreatePiece">

<!-- FORM CATEGORY SELECTIONS -->

      	<div>
        	<b-form-select v-model="category" :options="categoryOptions" label='Category' id="category-select"/>
      	</div>

      	<div>
        	<b-form-select v-model="series" :options="seriesOptions" label='Series' id="series-select" />
      	</div>

      	<div>
        	<b-form-select v-model="skill" :options="skillOptions" label='Skill' id="skill-select" />
      	</div>

<!-- INPUT DESCRIPTIVE TEXT -->

        <div class="form-group">
          <label for="inputTitle">Name of the Piece</label>
          <input type="text" class="form-control no-border" id="inputTitle" placeholder="Title" v-model="title" style="width:91%;"/>
        </div>

        <div class="form-group">
          <label for="previewText">Preview Text</label>
          <input type="text" class="form-control no-border" id="previewText" placeholder="One-sentence description" v-model="previewText" style="width:91%;"/>
        </div>

        <div class="form-group">
          <label for="description">Description</label>
          <textarea class="form-control no-border" id="description" placeholder="Full description"  v-model="description" style="width:91%;"/>
        </div>

<!-- INCLUDE ON LANDING PAGE, ADD IMAGE, VIDEO OR DOCUMENT --> 

        <div class="form-group">

<!-- FEATURE ON FRONT PAGE CHECKBOX -->

          <div class="form-check">
            <b-form-checkbox v-model="featured" name="check-button" switch>
              Front Page Featured
            </b-form-checkbox>
          </div>
        </div>

<!-- CHECKBOX TO ADD LINK TO PDF FILE -->

				<div class="form-check">
          <input class="form-check-input" type="checkbox" id="fileCheck" v-model="pdf"/>
          <label class="form-check-label" for="fileCheck">
            Add PDF
          </label>
        </div>

<!-- IF PDF CHECKBOX CHECKED DISPLAY FORM INPUT FOR ENTERING PDF LINK -->

        <div v-if="pdf" class="form-group">
          <label for="file">PDF link</label>
          <input type="text" class="form-control no-border" id="file" placeholder="PDF link (/filename.pdf)" v-model="file"/>
      	</div>

<!-- CHECKBOX TO ADD YOUTUBE VIDEO ID -->

				<div class="form-check">
          <input class="form-check-input" type="checkbox" id="vidCheck" v-model="video"/>
          <label class="form-check-label" for="vidCheck">
            Add Video
          </label>
        </div>
				
				<br>

<!-- IF VIDEO CHECKBOX CHECKED DISPLAY FORM INPUT FOR ENTERING YOUTUBE VIDEO ID -->

				<div v-if="video" class="form-group">
          <label for="inputVidId">Video Id</label>
          <input type="text" class="form-control no-border" id="inputVidId" placeholder="VideoID" v-model="vidId" />
        </div>

<!-- IF VIDEO CHECKBOX NOT CHECKED DISPLAY BUTTON TO SELECT A LOCAL IMAGE -->

        <div v-else>
          <b-button v-b-modal.modalPrevent v-if="!imageUrl" class="custom-button" @click="onPickFile">Upload Image</b-button>
          <input
            type="file"
            style="display:none;"
            ref="fileInput" 
            accept="image/*"
            @change="onFilePicked" />
          <img v-if="imageUrl" :src="imageUrl" height="150" alt="Image preview" class="preview"/>

          <br>

<!-- IF IMAGE ATTACHED SHOW BUTTON TO REMOVE ATTACHED IMAGE -->

          <b-button class="custom-button no-see" v-b-modal.modalPrevent v-if="imageUrl" @click="imageUrl = null, files = null">
            Remove
          </b-button>

        </div>
            
			</b-form>

<!-- END OF BOOTSTRAP-STYLED FORM -->

<!-- MODAL FOOTER WITH SUBMIT BUTTON -->

      <div slot="modal-footer" class="w-100">
        <b-button size="md" class="float-right custom-button" :disabled="!formIsValid" @click="onCreatePiece"><b-spinner small v-if="loading"/><span v-else >Add Piece</span></b-button>
      </div>

    </b-modal>

<!-- END OF MODAL -->

	</div>
</template>

<script>

//IMPORT MIXIN WITH SELECTOR DATA & FUNCTIONS TO HANDLE FILE SELECTION
import { addMixin } from '../../AddMixin'

export default {
	//INITIALIZE FORM DATA VARIABLES
	data() {
		return {
			video: false,
			pdf: false,
			category: null,
			series: null,
			skill: null,
			description: '',
			previewText: '',
			title: '',
			imageUrl: '',
			image: '',
			vidId: '',
			file: '',
			featured: false
		}
	},

	computed: {
		//FUNCTION TO VALIDATE REQUIRED FORM DATA
		formIsValid() {
			return (
				this.category !== '' &&
				this.series !== '' &&
				this.skill !== '' &&
				this.title !== '' &&
				this.previewText !== '' &&
				this.description !== '' &&
				(this.imageUrl !== '' || this.vidId !== '')
			)
		},

		//FUNCTION TO GET LOADING STATE FROM VUEX STORE
		loading() {
			return this.$store.getters.loading
		},

		//FUNCTION TO GET ERROR STATE FROM VUEX STORE
		error() {
			return this.$store.getters.error
		}
	},
	//INCLUDE IMPORTED MIXIN WITH SELECTOR DATA & FUNCTIONS TO HANDLE FILE SELECTION
	mixins: [addMixin],

	methods: {
		onReset() {
    //CLEAR ALL DATA FROM FORM ON CLICK OF RESET BUTTON
			this.imageUrl = ''
				(this.video = false),
				(this.pdf = false),
				(this.category = null),
				(this.series = null),
				(this.skill = null),
				(this.description = ''),
				(this.previewText = ''),
				(this.title = ''),
				(this.imageUrl = ''),
				(this.image = ''),
				(this.vidId = ''),
				(this.file = ''),
				(this.featured = false)

      //TRICK TO RESET / CLEAR NATIVE BROWSER FORM VALIDATION STATE
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},

		//FUNCTION HANDLING SUBMISSION OF ADD FORM
		onCreatePiece() {
		//IF FORM VALIDATION FUNCTION RETURNS 'FALSE' RETURN TO FORM
			if (!this.formIsValid) {
				return
			}
			
			//STORE INPUT DATA IN VARIABLES
			const pieceData = {
				title: this.title,
				category: this.category,
				image: this.image,
				description: this.description,
				series: this.series,
				skill: this.skill,
				previewText: this.previewText,
				vidId: this.vidId,
				featured: this.featured,
				file: this.file
			}

			//IF IMAGE ATTACHED DISPATCH VUEX ACTION TO ADD DATA TO FIREBASE AND IMAGE TO FIRESTORE
			if (this.image) {
				this.$store.dispatch('createPiece', pieceData)
				this.$refs.modalForm.hide()

			//OR IF NO IMAGE ATTACHED DISPATCH VUEX ACTION TO ADD DATA TO FIREBASE ONLY
			} else {
				this.$store.dispatch('createVideo', pieceData)
				this.$refs.modalForm.hide()
			}
			//RESET FORM, EMIT CALL TO ADMIN PAGE FOR 'PIECE ADDED' ALERT, CLOSE ALERT AFTER TIMEOUT
			this.onReset()
			this.$emit('pieceAdded')
			setTimeout(() => {
				this.$emit('closeIt')
			}, 4500)
		},

		//FUNCTION TO HANDLE BUTTON CLICK TO DISMISS ERROR AND DISPATCH ACTION TO CLEAR STATE OF ERROR IN VUEX STORE
		onDismissed() {
			this.$store.dispatch('clearError')
		}
	}
}
</script>